import { Theme } from "@amx/ux-twoui-theming";
import { INavLink, INavLinkStyleProps } from "@m365-admin/nav";
import React from "react";
import { Text } from "../../../Text/Text";
import { getLeftNavDirectLinkCalloutStyles, getLeftNavDirectLinkStyles } from "./LeftNavDirectLink.styles";
import { LeftNavDirectLinkInternalProps } from "./LeftNavDirectLink.types";

export const LeftNavDirectLink: React.FC<LeftNavDirectLinkInternalProps> = ({
    isSelected,
    text
}) => {
    return (
        <Text weightOverride={isSelected ? "semi-bold" : undefined}>{text}</Text>
    );
};

export const getLeftNavDirectLink = (navLink: LeftNavDirectLinkInternalProps, isLastLink: boolean, isNavCollapsed: boolean, theme: Theme): INavLink => {
    return {
        key: navLink.itemKey,
        name: <LeftNavDirectLink {...navLink} isSelected={navLink.isSelected} />,
        "aria-label": navLink["aria-label"],
        "data-bi-id": navLink["data-bi-id"],
        isSelected: navLink.isSelected,
        onClick: navLink.linkInteraction.interactionType === "withOnClick" ? navLink.linkInteraction.onClick : undefined,
        href: navLink.linkInteraction.interactionType === "withHref" ? navLink.linkInteraction.href : undefined,
        styles: (props: INavLinkStyleProps) => getLeftNavDirectLinkStyles(props, theme, isNavCollapsed, isLastLink),
        icon: navLink.icon,
        tooltipProps: {
            calloutProps: {
                styles: getLeftNavDirectLinkCalloutStyles(theme)
            },
            content: navLink.text
        },
    };
};
